const segment =
  (typeof process !== "undefined" && process.env.REACT_APP_PRODUCT_SEARCH_INDEX_PATH) ||
  "api/products/search-index";

export function normalizeProductSearchApiRoot(apiUrl) {
  return String(apiUrl || "").replace(/\/api\/?$/i, "").replace(/\/+$/, "");
}

export function buildProductSearchIndexUrl(apiRootOrFullConfigUrl) {
  const root = normalizeProductSearchApiRoot(apiRootOrFullConfigUrl);
  const path = String(segment).replace(/^\/+/, "").replace(/\/+$/, "");
  return `${root}/${path}`;
}

export function buildProductSearchIndexVersionUrl(apiRootOrFullConfigUrl) {
  return `${buildProductSearchIndexUrl(apiRootOrFullConfigUrl)}/version`;
}
